import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { EditorPageStickySaveDiscardButton } from 'components/EditorPageStickyFooter';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var EditFormWrapper = function EditFormWrapper(_ref) {
  var hasChanges = _ref.hasChanges,
    inContentManagerContext = _ref.inContentManagerContext,
    isLoading = _ref.isLoading,
    isSubmitDisabled = _ref.isSubmitDisabled,
    children = _ref.children,
    onSubmit = _ref.onSubmit,
    onDiscard = _ref.onDiscard;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var handleSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            e.preventDefault();
            onSubmit();
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleSubmit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/_jsxs("form", {
    onSubmit: handleSubmit,
    children: [children, /*#__PURE__*/_jsx(EditorPageStickySaveDiscardButton, {
      cardVariant: "raised",
      isDisabled: isSubmitDisabled,
      isSaving: isLoading,
      hasChanges: hasChanges,
      buttonText: t(inContentManagerContext ? 'actions_done' : 'actions_save_and_close'),
      onSave: onSubmit,
      onDiscard: onDiscard
    })]
  });
};
export default EditFormWrapper;